import React from 'react';
import { useFormik } from 'formik';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import * as Yup from 'yup';
import { FormattedMessage, injectIntl } from 'react-intl';
import * as auth from '../_redux/authRedux';
import { TextField } from '../../../components/TextFieldInput';

const initialValues = {
  email: '',
  code: '',
  password: '',
};

function ConfirmUser({ intl, history }) {
  const ForgotPasswordSchema = Yup.object().shape({
    email: Yup.string()
      .email(
        intl.formatMessage({
          id: 'GENERAL.WRONG_EMAIL',
        })
      )
      .required(
        intl.formatMessage({
          id: 'AUTH.VALIDATION.REQUIRED_FIELD',
        })
      ),
    code: Yup.string(),
  });

  const formik = useFormik({
    initialValues,
    validationSchema: ForgotPasswordSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setSubmitting(true);
      try {
        // await Auth.confirmSignUp(values.email, values.code)
      } catch (e) {
        console.error(e);
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <div className="d-flex flex-column">
      <div className="text-center mb-10 mb-lg-20">
        <h4>{intl.formatMessage({ id: 'AUTH.FORGOT.TITLE' })}</h4>
      </div>
      <form
        onSubmit={formik.handleSubmit}
        className="form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp"
      >
        {formik.status && (
          <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
            <div className="alert-text font-weight-bold">{formik.status}</div>
          </div>
        )}
        <TextField
          labelMinSize={100}
          field="email"
          inputSize="100%"
          formik={formik}
          label={intl.formatMessage({ id: 'AUTH.INPUT.EMAIL' })}
        />
        <TextField
          labelMinSize={100}
          field="code"
          inputSize="100%"
          formik={formik}
          label={intl.formatMessage({ id: 'CODE' })}
        />
        <TextField
          labelMinSize={100}
          field="password"
          inputSize="100%"
          formik={formik}
          label={intl.formatMessage({ id: 'AUTH.INPUT.NEW_PASSWORD' })}
          type="password"
        />

        <div
          className="form-group d-flex flex-wrap align-items-center"
          style={{ justifyContent: 'space-between' }}
        >
          <div style={{ minWidth: 80 }}></div>
          <Link
            to="/auth/login"
            className="text-dark-50 text-hover-primary my-3 mr-20"
            id="kt_login_forgot"
          >
            <FormattedMessage id="AUTH.LOGIN.BUTTON" />
          </Link>
          <button
            id="kt_login_forgot_submit"
            type="submit"
            className="btn btn-primary font-weight-bold"
            disabled={formik.isSubmitting}
          >
            {intl.formatMessage({ id: 'CONFIRM' })}
          </button>
        </div>
      </form>
    </div>
  );
}

export default injectIntl(connect(null, auth.actions)(ConfirmUser));
